export default "__VITE_ASSET__DxqSHd47__"